import React from 'react';
import PropTypes from 'prop-types';

const OptionsIcon = ({ fill, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.55574 9.55552H1.19426V1.19448H3.10127C3.43112 1.19448 3.69851 0.927088 3.69851 0.597241V0.597241C3.69851 0.267394 3.43112 0 3.10127 0H1.19426C0.537248 0 0 0.537416 0 1.19448V9.55552C0 10.2126 0.537248 10.75 1.19426 10.75H9.55574C10.2128 10.75 10.75 10.2126 10.75 9.55552V7.64862C10.75 7.31883 10.4827 7.05149 10.1529 7.05149V7.05149C9.82309 7.05149 9.55574 7.31883 9.55574 7.64862V9.55552ZM6.86807 0C6.53823 0 6.27083 0.267394 6.27083 0.597241V0.597241C6.27083 0.927088 6.53823 1.19448 6.86807 1.19448H8.71965L3.10554 6.80833C2.87465 7.03921 2.87464 7.41355 3.10553 7.64443V7.64443C3.3364 7.87531 3.71073 7.87531 3.94161 7.64444L9.55577 2.03043V3.88205C9.55577 4.21183 9.82311 4.47917 10.1529 4.47917V4.47917C10.4827 4.47917 10.75 4.21183 10.75 3.88205V0.5C10.75 0.223857 10.5261 0 10.25 0H6.86807Z" fill={fill} />
  </svg>

);

export default OptionsIcon;

OptionsIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

OptionsIcon.defaultProps = {
  fill: '#3C4757',
  width: 11,
  height: 11,
};
